import { type ReactNode } from 'react';
import { isValidEmail, isNonEmpty, EMAIL_MAX_LENGTH, checkString } from '../../helpers/validators';
import authCopy from '../authCopy';

const { errors } = authCopy;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function validateEmail(email: any): ReactNode {
    if (!isNonEmpty(email)) {
        return errors.emailRequired;
    } else if (!checkString({ maxLength: EMAIL_MAX_LENGTH })(email)) {
        return errors.emailMax;
    } else if (!isValidEmail(email)) {
        return errors.emailInvalid;
    }
    return null;
}
